import { ModuleWithProviders, NgModule } from '@angular/core';
import { GSAPDirective } from '@df/ui/display/gsap/gsap.directive';
import { providers } from './gsap.providers';

const directives = [GSAPDirective];

@NgModule({
    imports: [...directives],
    exports: [...directives]
})
export class GSAPModule {
    static forRoot(options?: Partial<gsap.plugins.ScrollTriggerInstanceVars>): ModuleWithProviders<GSAPModule> {
        return {
            ngModule: GSAPModule,
            providers: providers(options)
        };
    }
}
